/* A quiet five-step commission, submitted through Shopify's native contact form. */
(() => {
  'use strict';
  const t = (text, params) => window.LRSI18n?.t(text, params) ?? String(text).replace(/\{(\w+)\}/g, (match, key) => params && Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match);
  if (window.LRSCommissionForms) {
    window.LRSCommissionForms.init(document);
    return;
  }
  const instances = new Map();
  const dossiers = {
    'arden-green': { model: 'Defender 90', title: 'Arden Green' },
    'westminster': { model: 'Series', title: 'Westminster' },
    'golden-sand': { model: 'Defender 90', title: 'Golden Sand' },
    'blue-horizon': { model: 'Defender 90', title: 'Blue Horizon' },
    'miami-blue': { model: 'Defender 110', title: 'Miami Blue' },
    'the-miami-blue': { model: 'Defender 110', title: 'Miami Blue' }
  };
  const normalizeModel = input => {
    const text = String(input || '').replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    if (/^(?:Land Rover\s+)?Series(?:\s|$)/i.test(text)) return 'Series';
    if (/^(?:Land Rover\s+)?Defender\s*110\b/i.test(text)) return 'Defender 110';
    if (/^(?:Land Rover\s+)?Defender\s*90\b/i.test(text)) return 'Defender 90';
    return '';
  };
  const cleanText = (value, limit = 160) => String(value || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, limit);

  function init(scope = document) {
    const roots = [...scope.querySelectorAll('[data-lrs-contact]')];
    if (scope.matches?.('[data-lrs-contact]')) roots.unshift(scope);
    roots.forEach(root => {
      if (instances.has(root)) return;
      const form = root.querySelector('.lrs-commission-form');
      if (!form) return;
      const controller = new AbortController();
      const listen = (target, event, callback, options = {}) => target.addEventListener(event, callback, { ...options, signal: controller.signal });
      const reportStatus = status => root.dispatchEvent(new CustomEvent('lrs:commission:status', { bubbles: true, detail: { status } }));
      const success = form.querySelector('[data-contact-success]');
      const errors = form.querySelector('[data-contact-errors]');
      const record = { controller, cleanup: () => {} };
      instances.set(root, record);
      if (success) {
        reportStatus('success');
        if (success.getClientRects().length) success.focus({ preventScroll: true });
        return;
      }
      const steps = [...form.querySelectorAll('[data-contact-step]')];
      const controls = [...form.querySelectorAll('[data-brief-field]')];
      const vehicleChoices = controls.filter(control => control.dataset.briefField === 'vehicle');
      const radioGroups = new Map();
      controls.filter(control => control.type === 'radio').forEach(control => {
        const group = radioGroups.get(control.name) || [];
        group.push(control);
        radioGroups.set(control.name, group);
      });
      const radioPeers = control => radioGroups.get(control.name) || [control];
      const body = form.querySelector('[data-contact-body]');
      const inspiration = form.querySelector('[data-contact-inspiration]');
      const inspirationNote = form.querySelector('[data-inspiration-note]');
      const progress = form.querySelector('[data-contact-progress]');
      const count = form.querySelector('[data-contact-step-count]');
      const stageButtons = [...form.querySelectorAll('[data-contact-go]')];
      const back = form.querySelector('[data-contact-back]');
      const next = form.querySelector('[data-contact-next]');
      const send = form.querySelector('[data-contact-send]');
      const stepError = form.querySelector('[data-contact-step-error]');
      const enhanced = steps.length === 5 && progress && back && next && send;
      const originalNoValidate = form.noValidate;
      const fieldErrors = new Map();
      let currentStep = 0;
      let furthestStep = 0;

      const updateInspiration = title => {
        if (inspiration) inspiration.value = cleanText(title);
        if (!inspirationNote) return;
        inspirationNote.hidden = !inspiration?.value;
        inspirationNote.textContent = inspiration?.value ? t(root.dataset.inspirationMessage || 'Inspired by [vehicle].').replace('[vehicle]', inspiration.value) : '';
      };
      const validationsIn = index => {
        const panelControls = controls.filter(control => steps[index]?.contains(control));
        // A radio group has one validation message and one focus target.
        return panelControls.filter(control => control.type !== 'radio' || control === radioPeers(control)[0]);
      };
      const validateText = control => {
        if (control.type === 'radio') return;
        const emptyText = control.required && control.value.length > 0 && !control.value.trim();
        control.setCustomValidity(emptyText ? t(root.dataset.requiredMessage || 'Please complete this field.') : '');
      };
      const removeError = control => {
        const entry = fieldErrors.get(control);
        if (!entry) return;
        entry.node.remove();
        entry.fields.forEach(field => {
          const describedBy = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== entry.node.id);
          if (describedBy.length) field.setAttribute('aria-describedby', describedBy.join(' '));
          else field.removeAttribute('aria-describedby');
          field.removeAttribute('aria-invalid');
        });
        fieldErrors.delete(control);
      };
      const showError = control => {
        removeError(control);
        const node = document.createElement('p');
        node.className = 'lrs-funnel-field-error form-note';
        node.id = `${control.id}-funnel-error`;
        node.textContent = t(control.type === 'radio' ? ({ vehicle: 'Choose a model variant.', engine: 'Choose Diesel or Petrol.', roof: 'Choose Hardtop or Softtop.', materials: 'Choose a material.' }[control.dataset.briefField] || 'Choose an option.') : control.validity.typeMismatch && control.type === 'email' ? 'Please enter a valid email address.' : control.validity.valueMissing || control.validity.customError ? t(root.dataset.requiredMessage || 'Please complete this field.') : control.validationMessage);
        const fields = control.type === 'radio' ? radioPeers(control) : [control];
        fields.forEach(field => {
          field.setAttribute('aria-invalid', 'true');
          const describedBy = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
          describedBy.push(node.id);
          field.setAttribute('aria-describedby', [...new Set(describedBy)].join(' '));
        });
        const host = control.type === 'radio' ? control.closest('.lrs-choice-group') : control;
        host.insertAdjacentElement('afterend', node);
        fieldErrors.set(control, { node, fields });
      };
      const clearStepMessage = () => {
        if (!stepError) return;
        stepError.hidden = true;
        stepError.textContent = '';
      };
      const showStep = (index, focus = true) => {
        if (!enhanced || index < 0 || index >= steps.length) return;
        const changed = currentStep !== index;
        currentStep = index;
        furthestStep = Math.max(furthestStep, index);
        steps.forEach((panel, position) => {
          panel.hidden = position !== index;
          panel.setAttribute('tabindex', '-1');
        });
        if (count) {
          count.textContent = `${index + 1} / ${steps.length}`;
          count.setAttribute('aria-label', t('Step {current} of {total}', {current:index + 1, total:steps.length}));
        }
        stageButtons.forEach((button, position) => {
          button.disabled = position > furthestStep;
          if (position === index) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
          button.closest('li')?.classList.toggle('is-complete', position < index);
        });
        back.hidden = index === 0;
        next.hidden = index === steps.length - 1;
        send.hidden = index !== steps.length - 1;
        form.dataset.currentStep = String(index + 1);
        clearStepMessage();
        if (focus) steps[index].focus({ preventScroll: true });
        if (changed) root.dispatchEvent(new CustomEvent('lrs:commission:step', { bubbles: true, detail: { step: index + 1, total: steps.length } }));
      };
      const validateStep = (index, revealErrors = true) => {
        const fields = validationsIn(index);
        fields.forEach(control => {
          if (control.type !== 'radio') control.value = control.value.trim();
          validateText(control);
          if (control.validity.valid) removeError(control);
        });
        const invalid = fields.filter(control => !control.validity.valid);
        if (invalid.length && revealErrors) {
          invalid.forEach(showError);
          if (stepError) {
            stepError.textContent = t('A few details to complete.');
            stepError.hidden = false;
          }
          invalid[0].focus({ preventScroll: false });
        }
        return invalid.length === 0;
      };
      const advance = () => {
        if (validateStep(currentStep)) showStep(Math.min(currentStep + 1, steps.length - 1));
      };
      const selectModel = (input, title) => {
        const key = String(input || '').trim().toLowerCase();
        const reference = Object.prototype.hasOwnProperty.call(dossiers, key) ? dossiers[key] : null;
        const model = normalizeModel(input) || reference?.model;
        const choice = vehicleChoices.find(control => control.value === model);
        if (!choice) return false;
        choice.checked = true;
        choice.dispatchEvent(new Event('change', { bubbles: true }));
        if (title !== undefined || reference) updateInspiration(title || reference?.title || '');
        showStep(0, false);
        return true;
      };
      listen(root, 'lrs:commission:select', event => {
        selectModel(event.detail?.model || event.detail?.vehicle, event.detail?.title || '');
      });
      listen(root, 'lrs:commission:reset', () => { if (!errors) showStep(0, false); });
      const handleInput = event => {
        const control = event.target;
        if (!control.matches('[data-brief-field]')) return;
        validateText(control);
        const validationControl = control.type === 'radio' ? radioPeers(control)[0] : control;
        if (validationControl?.validity.valid) removeError(validationControl);
        if (control.getAttribute('aria-invalid') === 'true' && control.validity.valid && !fieldErrors.has(validationControl)) control.removeAttribute('aria-invalid');
        if (validationsIn(currentStep).every(field => field.validity.valid)) clearStepMessage();
      };
      listen(form, 'input', handleInput);
      listen(form, 'change', handleInput);
      if (enhanced) {
        // JS validates the visible step and reveals hidden invalid fields before focus.
        // Without JS, all fieldsets stay visible and browser validation remains native.
        form.noValidate = true;
        form.classList.add('is-funnel');
        progress.hidden = false;
        if (count) {
          count.setAttribute('aria-live', 'polite');
          count.setAttribute('aria-atomic', 'true');
        }
        showStep(0, false);
        listen(next, 'click', advance);
        listen(back, 'click', () => showStep(currentStep - 1));
        stageButtons.forEach(button => listen(button, 'click', () => {
          const target = Number(button.dataset.contactGo);
          if (target < currentStep || target <= furthestStep && validateStep(currentStep)) showStep(target);
        }));
      }
      listen(form, 'submit', event => {
        if (enhanced && currentStep < steps.length - 1) {
          event.preventDefault();
          advance();
          return;
        }
        if (enhanced) {
          const invalidStep = steps.findIndex((panel, index) => !validateStep(index, false));
          if (invalidStep !== -1) {
            event.preventDefault();
            showStep(invalidStep, false);
            validateStep(invalidStep);
            return;
          }
          const valueOf = key => {
            const fields = controls.filter(control => control.dataset.briefField === key);
            const raw = (fields.find(control => control.type !== 'radio' || control.checked) || {}).value;
            return key === 'vision' ? String(raw || '').trim().slice(0, 3000) : cleanText(raw, 254);
          };
          if (body) {
            body.value = [
              'PRIVATE COMMISSION',
              '',
              `Model variant: ${valueOf('vehicle')}`,
              `Engine: ${valueOf('engine')}`,
              `Roof: ${valueOf('roof')}`,
              `Materials: ${valueOf('materials')}`,
              ...(inspiration?.value ? [`Vehicle inspiration: ${inspiration.value}`] : []),
              '',
              'How the Land Rover should feel:',
              valueOf('vision'),
              '',
              `Name: ${valueOf('name')}`,
              `Email: ${valueOf('email')}`,
              `Phone: ${valueOf('phone')}`,
              `Delivery destination: ${valueOf('city')}, ${valueOf('country')}`
            ].join('\n');
          }
          reportStatus('submitting');
        } else {
          controls.filter(control => control.type !== 'radio').forEach(control => {
            control.value = control.value.trim();
            validateText(control);
          });
          if (!form.checkValidity()) {
            event.preventDefault();
            form.reportValidity();
          }
        }
        // Keep every input enabled. Shopify receives all five steps in one native POST.
      }, { capture: true });

      const query = new URLSearchParams(window.location.search);
      const requestedVehicle = cleanText(query.get('vehicle'), 120);
      const dossier = Object.prototype.hasOwnProperty.call(dossiers, requestedVehicle) ? dossiers[requestedVehicle] : null;
      if (!vehicleChoices.some(control => control.checked)) selectModel(query.get('model') || dossier?.model || requestedVehicle);
      updateInspiration(inspiration?.value || cleanText(query.get('title')) || dossier?.title || (requestedVehicle && !normalizeModel(requestedVehicle) ? requestedVehicle : ''));
      if (errors) {
        const serverInvalid = controls.find(control => control.getAttribute('aria-invalid') === 'true');
        if (serverInvalid && enhanced) showStep(steps.findIndex(panel => panel.contains(serverInvalid)), false);
        reportStatus('error');
        if (errors.getClientRects().length) errors.focus({ preventScroll: true });
      }
      record.cleanup = () => {
        form.noValidate = originalNoValidate;
        form.classList.remove('is-funnel');
        delete form.dataset.currentStep;
        steps.forEach(panel => { panel.hidden = false; panel.removeAttribute('tabindex'); });
        if (progress) progress.hidden = true;
        if (back) back.hidden = true;
        if (next) next.hidden = true;
        if (send) send.hidden = false;
        [...fieldErrors.keys()].forEach(removeError);
        clearStepMessage();
      };
    });
  }
  function unload(scope) {
    for (const [root, record] of instances) {
      if (root === scope || scope.contains(root)) {
        record.controller.abort();
        record.cleanup();
        instances.delete(root);
      }
    }
  }
  window.LRSCommissionForms = { init, unload, normalizeModel };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
})();
